/** PP Appearance: one verified Physical Purity reading, read-only. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { PpAppearanceDetailPage } from "@/features/arrival/components/pp-appearance/pp-appearance-detail-page";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app/arrivals/pp-appearance/$sampleId")({
  params: {
    parse: ({ sampleId }) => {
      if (!/^\d+$/.test(sampleId)) throw notFound();
      return { sampleId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <PpAppearanceDetailPage sampleId={Number(sampleId)} />;
}
